import React, { type FC } from 'react';

import SelectClearIcon from '@atlaskit/icon/core/cross-circle';

import type { SearchCSS } from '../theme';
import { ClearIconWrapper } from './clear-icon-wrapper';
import { InputBoxOverlayRight } from './input-box-overlay-right';

type SearchInputOverlayProps = {
	allowChangeExpand?: (expand: boolean) => void;
	onClear?: () => void;
	theme: SearchCSS;
	showClearButton?: boolean;
	clearSearchLabel?: string;
	toggleAISearchButton?: React.JSX.Element;
};

export const SearchInputOverlay: FC<SearchInputOverlayProps> = ({
	theme,
	showClearButton,
	onClear,
	allowChangeExpand,
	clearSearchLabel,
	toggleAISearchButton,
}) => {
	return (
		<InputBoxOverlayRight>
			{showClearButton && (
				<ClearIconWrapper
					{...theme}
					role="button"
					onClick={onClear}
					onMouseEnter={() => {
						allowChangeExpand?.(false);
					}}
					onMouseLeave={() => {
						allowChangeExpand?.(true);
					}}
					tabIndex={0}
				>
					<SelectClearIcon
						color="currentColor"
						label={clearSearchLabel || 'Clear search session'}
					/>
				</ClearIconWrapper>
			)}
			{toggleAISearchButton}
		</InputBoxOverlayRight>
	);
};
